import clsx from 'clsx';

import Container from '@modules/common/components/container';

const SkeletonPulse = ({ className }: { className?: string }) => (
  <div className={clsx('animate-pulse rounded bg-gray-200', className)} />
);

export const SkeletonOrderConfirmed = () => {
  return (
    <div className="min-h-[calc(100vh-64px)] py-6">
      <Container className="flex min-h-[90vh] w-full flex-col items-center justify-center gap-y-10">
        <div className="flex h-full w-full max-w-[1440px] flex-col gap-4 bg-white py-10 px-4">
          {/* 步驟指示器 skeleton */}
          <div className="mb-12 flex justify-center gap-4">
            <SkeletonPulse className="h-10 w-10 rounded-full" />
            <SkeletonPulse className="mb-6 h-1 w-[200px] self-center" />
            <SkeletonPulse className="h-10 w-10 rounded-full" />
            <SkeletonPulse className="mb-6 h-1 w-[200px] self-center" />
            <SkeletonPulse className="h-10 w-10 rounded-full" />
          </div>

          {/* 購物車摺疊區 skeleton */}
          <div className="mb-12">
            <SkeletonPulse className="h-24 w-full rounded-md" />
          </div>

          {/* 訂單資訊 skeleton */}
          <div className="flex flex-col items-center gap-4">
            <SkeletonPulse className="h-8 w-64" />
            <SkeletonPulse className="h-5 w-48" />
            <SkeletonPulse className="h-5 w-80" />
          </div>

          {/* 資訊區塊 skeleton */}
          <div className="mt-6 flex gap-6">
            <SkeletonPulse className="h-48 flex-1 rounded-md" />
            <SkeletonPulse className="h-48 flex-1 rounded-md" />
          </div>
        </div>
      </Container>
    </div>
  );
};
